export default __webpack_public_path__ + "static/media/GhostDeer.b734d88b.png";